var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.948 3.19336C11.1309 2.1083 12.7223 1.56578 13.5783 2.42174C14.4342 3.27771 13.8917 4.86914 12.8067 8.052L12.0677 10.2195C11.2345 12.6639 10.8178 13.8861 10.1309 13.9872C9.94633 14.0144 9.7552 13.9981 9.57246 13.9394C8.893 13.7213 8.5338 12.4326 7.8154 9.85534C7.65606 9.28367 7.5764 8.9978 7.39493 8.77947C7.34226 8.71614 7.28386 8.65774 7.22053 8.60507C7.0022 8.4236 6.71633 8.34394 6.1447 8.1846C3.5674 7.4662 2.27876 7.107 2.0606 6.42752C2.00194 6.24483 1.98558 6.05369 2.01277 5.86903C2.11392 5.18221 3.33612 4.76556 5.78053 3.93225L7.948 3.19336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/send-button.c2ded2b6e00a5490c3e4905c580841da.svg";
export { ForwardRef as ReactComponent };